import { useTranslation } from 'react-i18next'
import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { HouseConsignmentFormValues } from 'features/declaration/house-consignment/models/schema'
import useCodelist from 'features/declaration/codelist/api/useCodelist'
import useDeclarationFieldRequirements from '../../form/components/useDeclarationFieldRequirements'
import FormCollapsibleColumn from '../../../../components/p5/FormCollapsibleColumn'
import Input from '../../../../components/p5/Input'
import FormField from '../../../../components/p5/FormField'
import FormSelect from '../../../../components/p5/FormSelect'

const scope = 'placeOfDelivery'

function PlaceOfDelivery() {
  const { control } = useFormContext<HouseConsignmentFormValues>()

  const { t } = useTranslation()
  const [, countriesOptions] = useCodelist('COUNTRIES')

  const isDifferentPlaceOfDelivery = useWatch({
    control,
    name: 'differentPlaceOfDelivery',
  })

  const fieldRequirements = useDeclarationFieldRequirements<HouseConsignmentFormValues>('houseConsignment', [
    'differentPlaceOfDelivery',
    'placeOfDelivery',
    'placeOfDelivery.country',
    'placeOfDelivery.nationality',
    'placeOfDelivery.location',
  ])

  return (
    <section className="py-3">
      <FormCollapsibleColumn
        columnId="declaration-loading-place"
        headingLabel={t('declaration.p5.placeOfDelivery')}
        fieldRule={fieldRequirements[scope]}
      >
        <div className="row mb-2">
          <div className="d-flex mb-2 col-8">
            <Input
              field="differentPlaceOfDelivery"
              type="checkbox"
              labelKey="Different place of delivery from consignment"
              fieldRule={fieldRequirements.differentPlaceOfDelivery}
            />
          </div>
        </div>
        {isDifferentPlaceOfDelivery && (
          <>
            <FormField
              labelKey="declaration.p5.nationality"
              fieldRule={fieldRequirements[`${scope}.country`]}
            >
              <FormSelect
                field={`${scope}.country`}
                labelKey="declaration.p5.nationality"
                options={countriesOptions}
                type="sync"
                fieldRule={fieldRequirements[`${scope}.country`]}
              />
            </FormField>
            <FormField
              labelKey="declaration.p5.placeOfDeliveryLocation"
              fieldRule={fieldRequirements[`${scope}.location`]}
            >
              <Input
                field={`${scope}.location`}
                labelKey="declaration.p5.placeOfDeliveryLocation"
                type="text"
                maxLength={35}
                placeholder={t('declaration.p5.placeOfDeliveryLocation')}
                fieldRule={fieldRequirements[`${scope}.location`]}
              />
            </FormField>
          </>
        )}
      </FormCollapsibleColumn>
    </section>
  )
}

export default PlaceOfDelivery
